import React from "react";
//import * as XLSX from "xlsx";
import * as XLSX from "xlsx-with-styles";
import { FaFileExcel } from "react-icons/fa";
import { adminService } from "../../../api/admin";
import moment from "moment";

const ExportExcel = (prop) => {
  const createExcel = () => {
    let token = localStorage.getItem("token");

    let params = {
      token: token,
      date: prop.date,
      courseType: prop.courseType,
    };

    adminService
      .downloadCertificatesDailyReport(params)
      .then((response) => {
        //--- ---

        // Dati da inserire nel file Excel
        /* HEADER COMMENTATO
        const header1 = [
          [
            "ELENCO PERSONALE ALIMENTARISTA CHE HA FREQUENTATO CON PROFITTO IL CORSO DI FORMAZIONE ORGANIZZATO DA",
          ],
        ]; // Header1

        const header2 = [
          ["denominazione ente: LAB.MAR DEL DOTT.CALOGERO CECATO"],
        ]; // Header2

        const header4 = [
          [
            "iscritto nel registro regionale per la formazione degli alimentaristi con al n.2021/356 del 24/06/2021",
          ],
        ]; // Header4

        const header5 = [
          [
            "comunicazione di attivazione corso inviata in data " +
              (moment(prop.protocolloAA).format("DD/MM/YYYY") ||
                "____/____/____"),
          ],
        ]; // Header5

        const header7 = [
          [
            "durata del corso: " +
              (prop.courseType === "haccp6" ? "6 ore" : "12 ore"),
          ],
        ]; // Header7
        const header9 = [
          ["IN MODALITA' FAD ASINCRONA (FROMAZIONE A DISTANZA) "],
        ]; // Header9

        const emptyRow = [[]]; // Riga vuota per separare l'header dalla tabella
        */
        const tableHeader = [
          [
            "NOME",
            "COGNOME",
            "LUOGO DI NASCITA",
            "DATA DI NASCITA",
            "CODICE FISCALE",
            "DATA INIZIO",
            "DATA ESAME FINALE",
            "ATTESTATO N.",
          ],
        ]; // Intestazioni della tabella

        const tableData = response.data.payload.data.map((item) => {
          item.birthDate =
            moment(item.dateOfBirth).format("DD/MM/YYYY") !== "Invalid date"
              ? moment(item.dateOfBirth).format("DD/MM/YYYY")
              : item.dateOfBirth;

          item.examDate =
            moment(item.releasedAt).format("DD/MM/YYYY") !== "Invalid date"
              ? moment(item.releasedAt).format("DD/MM/YYYY")
              : item.releasedAt;

          item.startedAt =
            moment(item.startedAt).format("DD/MM/YYYY") !== "Invalid date"
              ? moment(item.startedAt).format("DD/MM/YYYY")
              : item.startedAt;

          item.certificateNumber = item.progress_aa;

          return [
            item.name,
            item.surname,
            item.birthCity,
            item.birthDate,
            item.fiscalCode,
            item.startedAt,
            item.examDate,
            item.certificateNumber,
          ];
        });

        // Combina l'header, la riga vuota, l'intestazione della tabella e i dati della tabella
        const data = [
          // ...header1,
          // ...header2,
          // ...header4,
          // ...header5,
          // ...header7,
          // ...header9,
          // ...emptyRow,
          ...tableHeader,
          ...tableData,
        ];

        // Crea un nuovo workbook e un nuovo foglio
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.aoa_to_sheet(data);

        // Impostazioni di stampa per A4 landscape
        ws["!pageSetup"] = {
          orientation: "landscape",
          paperSize: 9, // 9 = A4
          fitToWidth: 1, // Adatta il contenuto alla larghezza
          fitToHeight: 0, // Nessun limite in altezza
        };

        // Unisci le celle dell'header su 8 colonne (A-H) - commentato insieme alle righe header
        /* MERGES HEADER COMMENTATO
        ws["!merges"] = [
          { s: { r: 0, c: 0 }, e: { r: 0, c: 7 } }, // Unisce la prima riga da colonna 0 a colonna 7
          { s: { r: 1, c: 0 }, e: { r: 1, c: 7 } }, // Unisce la seconda riga da colonna 0 a colonna 7
          { s: { r: 2, c: 0 }, e: { r: 2, c: 7 } }, // Unisce la quarta riga da colonna 0 a colonna 7
          { s: { r: 3, c: 0 }, e: { r: 3, c: 7 } }, // Unisce la quinta riga da colonna 0 a colonna 7
          { s: { r: 4, c: 0 }, e: { r: 4, c: 7 } }, // Unisce la sesta riga da colonna 0 a colonna 7
          { s: { r: 5, c: 0 }, e: { r: 5, c: 7 } }, // Unisce la settima riga da colonna 0 a colonna 7
          { s: { r: 6, c: 0 }, e: { r: 6, c: 7 } }, // Unisce l'ottava riga da colonna 0 a colonna 7
        ];
        */

        // Applica stile a tutte le celle (tableHeader è ora riga 0)
        for (let row = 0; row <= tableData.length; row++) {
          for (let col = 0; col <= 7; col++) {
            const cellRef = XLSX.utils.encode_cell({ r: row, c: col });
            if (ws[cellRef]) {
              ws[cellRef].s = {
                alignment: {
                  horizontal: "center",
                  vertical: "center",
                  wrapText: false,
                },
                font:
                  row === 0
                    ? { bold: true, sz: 12 }
                    : { sz: 12 },
              };
            }
          }
        } //for

        // Imposta la larghezza della prima colonna a 250
        ws["!cols"] = [
          { width: 30 },
          { width: 30 },
          { width: 30 },
          { width: 20 },
          { width: 22 },
          { width: 20 },
          { width: 20 },
          { width: 20 },
        ];

        // Aggiungi il foglio al workbook
        XLSX.utils.book_append_sheet(wb, ws, "Foglio1");

        // Genera il file Excel come array buffer
        const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const blob = new Blob([wbout], { type: "application/octet-stream" });

        // Crea un link per forzare il download
        const filename =
          "reportGiornalieroCertificati_" +
          prop.date.replace(/-/g, "") +
          "_" +
          prop.courseType;

        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename + ".xlsx";
        document.body.appendChild(a);
        a.click();

        // Rimuovi il link dopo il download
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        //--- ---
      })
      .catch((error) => {
        //alert("error");
      });
  };

  return (
    <div>
      <FaFileExcel
        className={prop.class}
        onClick={() => {
          createExcel();
        }}
      />
      <div style={{ textAlign: "center" }}>{prop.cnt}</div>
    </div>
  );
};

export default ExportExcel;
